jQuery('.mobile-toggle .hamburger').click(function(){
	
	jQuery('#navigation').addClass('menu-open');
	
	jQuery('.mobile-row').hide();
	
	jQuery('.mobile-menu > #main-nav').show();
	
});

jQuery('.mobile-toggle .close').click(function(){
	
	jQuery('#navigation').removeClass('menu-open');
	
	jQuery('.mobile-row').hide();
	
	jQuery('.mobile-menu > #main-nav').hide();
	
});
